import React from 'react';
import classNames from 'classnames';

import Copy from 'Src/components/Copy';
import SalidoLoadingIcon from 'Src/components/icons/svg/SalidoLoadingIcon';
import { BackDrop } from 'Src/feature/back-drop/BackDrop';

import styles from './WaitSplash.module.scss';

interface WaitSplashProps {
  message: string;
}

const WaitSplash: React.FC<WaitSplashProps> = ({ message }) => (
  <BackDrop className={styles.backdrop} open>
    <div className={classNames(styles.container)}>
      <SalidoLoadingIcon className={styles.icon} />
      <Copy className={styles.message} value={message} />
    </div>
  </BackDrop>
);

export default WaitSplash;
export type { WaitSplashProps };
